import classNames from 'classnames';
import React, { PropsWithChildren } from 'react';
import Title from './components/Title';
import styles from './styles.module.scss';

type Props = PropsWithChildren<{
  title: string;
  isOpen?: boolean;
  onClose: () => void;
  dataTestId?: string;
}>;

const Panel: React.FunctionComponent<Props> = (props) => {
  const { title, children, isOpen = false, onClose, dataTestId = 'panel' } = props;

  return (
    <div className={classNames(styles.container, { [styles.isOpen]: isOpen })} data-testid={dataTestId}>
      <Title onClose={onClose} dataTestId={`${dataTestId}-title`}>
        {title}
      </Title>
      <div className={styles.body} data-testid={`${dataTestId}-body`}>
        {isOpen ? children : null}
      </div>
    </div>
  );
};

export default Panel;
